import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconColumnWideRemove: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconColumnWideRemove"><Path d="M2 4V20H12.75V5.5H20.5V11H22V4H2Z" fill="currentColor"/><Path d="M16.75 13.6893L15.6893 14.75L17.9393 17L15.6893 19.25L16.75 20.3107L19 18.0607L21.25 20.3107L22.3107 19.25L20.0607 17L22.3107 14.75L21.25 13.6893L19 15.9393L16.75 13.6893Z" fill="currentColor"/></CentralIconBase>;
});

export default IconColumnWideRemove;
